import styled, { css } from "styled-components";
import tokens from "../../theme/tokens";

export const ActivityWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

export const PillRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
`;

export const MetaRow = styled.div`
  display: flex;
  gap: 6px;
  font-family: ${tokens.typography.fontFamily};
  font-size: 11px;
  color: ${tokens.text.muted};
  white-space: nowrap;
`;

export const QuietText = styled.span`
  font-family: ${tokens.typography.fontFamily};
  font-size: 12px;
  font-style: italic;
  color: ${tokens.text.disabled};
`;

const toneStyles = {
  info: css`
    color: ${tokens.status.processing.fg};
    background: ${tokens.status.processing.bg};
    border-color: ${tokens.status.processing.border};
  `,
  warning: css`
    color: ${tokens.status.review.fg};
    background: ${tokens.status.review.bg};
    border-color: ${tokens.status.review.border};
  `,
  neutral: css`
    color: ${tokens.status.neutral.fg};
    background: ${tokens.status.neutral.bg};
    border-color: ${tokens.status.neutral.border};
  `,
};

export const ActivityPill = styled.span`
  display: inline-flex;
  align-items: center;
  border: 1px solid transparent;
  border-radius: 9999px;
  font-family: ${tokens.typography.fontFamily};
  font-size: 11px;
  font-weight: ${tokens.typography.weight.semibold};
  line-height: 1;
  padding: 3px 8px;
  height: 20px;
  letter-spacing: 0.01em;
  white-space: nowrap;

  ${(p) => toneStyles[p.$tone] || toneStyles.neutral}
`;
